// extracted by mini-css-extract-plugin
module.exports = {"header-element":"HeaderElement_header-element__31JyT"};